import forge from 'node-forge';

export const encryptAutologinInfo = (publicRSA, dataSend) => {
  const publicKeyPem = forge.pki.publicKeyFromPem(publicRSA);
  const encrypted = publicKeyPem.encrypt(JSON.stringify(dataSend));
  const encryptedData = forge.util.encode64(encrypted);
  return { token: encryptedData };
};

export const encryptIdentifier = identifier => {
  const publicRSA = process.env.APP_IDENTIFIER_PUBLIC_RSA;
  const publicKeyPem = forge.pki.publicKeyFromPem(publicRSA);
  const encrypted = publicKeyPem.encrypt(identifier.toString());
  const encryptedData = forge.util.encode64(encrypted);
  const encryptedDataEncode = encodeURIComponent(encryptedData);
  return encryptedDataEncode;
};
